import shopeeImage from 'Asset/image/shopee-image.png';
import tiktokImage from 'Asset/image/tiktok-image.png';

const getPlatformIcon = (platform) => {
  switch (platform) {
    case 'Shopee':
      return shopeeImage;
    default:
      return tiktokImage;
  }
};

export default getPlatformIcon;
